import React, { useEffect, useRef } from 'react';
import { Avatar, Button, Checkbox, Input } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const ReplyComposer = ({ comment, user, text, isPublic, busy, onTextChange, onPrivacyChange, onCancel, onSubmit }) => {
  const container = useRef(null);
  const input = useRef(null);
  useEffect(() => {
    input.current?.focus?.({ preventScroll: true });
    container.current?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
  }, []);
  const name = comment.user?.nickname || comment.user?.username || '用户';
  return <div className="commentThreads-reply-composer" ref={container}>
    <Avatar src={user?.avatar || undefined} icon={<UserOutlined />} />
    <div className="commentThreads-reply-body">
      <Input.TextArea ref={input} aria-label="回复内容" value={text} disabled={busy} onChange={event => onTextChange(event.target.value)}
        placeholder={`回复 @${name}：`} maxLength={500} showCount autoSize={{ minRows: 2, maxRows: 6 }} />
      <div className="commentThreads-reply-footer">
        <Checkbox checked={!isPublic} disabled={busy || comment.is_public === false} onChange={event => onPrivacyChange(!event.target.checked)}>
          私密回复（仅讨论参与者和帖主可见）
        </Checkbox>
        <div className="post-detail-composer-actions">
          <Button disabled={busy} onClick={onCancel}>取消回复</Button>
          <Button type="primary" loading={busy} disabled={busy || !text.trim()} onClick={onSubmit}>发表回复</Button>
        </div>
      </div>
    </div>
  </div>;
};

export default ReplyComposer;
